/**
 * "DEINE BOX" — Signature 1, live updates.
 * Keeps the header's box icon (candy-cart-box-icon.liquid) in sync with the
 * cart: fill height tracks total-vs-threshold, the ribbon ties itself once
 * free shipping unlocks, and every successful add gives the box a visible
 * squish — the box builder already does this exact "impact" treatment on
 * its own summary panel (candy-bundle-builder.liquid), this is the same
 * material applied to the header icon so the two feel like one theme
 * language rather than two unrelated effects.
 *
 * Same event bus as the shipping jar (candy-shipping-bar.js) and the
 * add-on guard — no extra network requests beyond what a normal cart
 * change already triggers.
 */
(function () {
  // querySelectorAll, not querySelector: the header icon and the floating
  // box BOTH carry [data-cart-box], so the singular form updated only the
  // header and left the floating box's fill and ribbon frozen at whatever
  // the page was rendered with.
  function update(totalCents) {
    var boxes = document.querySelectorAll('[data-cart-box]');
    boxes.forEach(function (box) {
      var threshold = parseInt(box.dataset.thresholdCents, 10);
      if (!threshold) return;

      var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
      var unlocked = totalCents >= threshold && totalCents > 0;

      box.style.setProperty('--candy-box-fill', pct + '%');
      box.classList.toggle('is-unlocked', unlocked);
    });
  }

  function pulse() {
    document.querySelectorAll('[data-cart-box]').forEach(function (box) {
      box.classList.remove('candy-cart-box--pulse');
      // Force reflow so re-adding the class restarts the animation even if
      // it fired very recently (rapid successive adds).
      void box.offsetWidth;
      box.classList.add('candy-cart-box--pulse');
    });
  }

  function refreshFromServer() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) { update(cart.total_price); })
      .catch(function () {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cartData = event && event.cartData;
      if (cartData && typeof cartData.total_price !== 'undefined') {
        update(cartData.total_price);
      } else {
        refreshFromServer();
      }
      if (!window.__candyFlightActive) pulse();
    });
  }

  document.addEventListener('cart:refresh', refreshFromServer);

  // candy-fly-to-cart.js fires the squish on landing rather than on the
  // cart event, so it needs a handle on it.
  window.CandyCartBox = { pulse: pulse, update: update, refresh: refreshFromServer };
})();
